import { Breadcrumb, Col, Collapse, Row, List } from "antd";
import Modal from "components/Modal";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router";
import cls from "./QuickViewModal.module.scss";
import MetaDataCard from "./MetaDataCard";
import {
  ArrowCurvedRight,
  Bank,
  Clock,
  Document,
  User,
  ChevronRight,
  Times,
} from "assets/icons";
import { Space } from "antd";
import myGov from "../../../assets/images/mygov.png";
import birDarcha from "../../../assets/images/birdarcha.png";
import davXizmat from "../../../assets/images/davxizmat.png";

const ServicePoint = ({ imgSrc, title }) => {
  return (
    <div className={cls.servicePoint}>
      <img src={imgSrc} alt="service point" />
      <span>{title}</span>
      <ChevronRight />
    </div>
  );
};

const QuickViewModal = () => {
  const { t } = useTranslation();
  const { hash } = useLocation();
  const navigate = useNavigate();

  const text = `
  A dog is a type of domesticated animal.
  Known for its loyalty and faithfulness,
  it can be found as a welcome guest in many households across the world.
`;

  const data = [
    {
      title:
        "Avtomobil transportida yo‘lovchilarni va yuklarni tashishga litsenziya olish",
    },
    {
      title:
        "Avtotransport vositalari oynalarining tusini o'zgartirishga (qoraytirish) ruxsatnoma olish",
    },
    {
      title:
        "Avtomototransport vositasi konstruksiyasini va (yoki) uning qismini o‘zgartirish. Avtomototransport vositasining kuzovi hamda detallarini o‘zgartirish bilan bog‘liq faoliyat",
    },
  ];

  const items = [
    {
      key: "1",
      label: "Davlat xizmatini ko‘rsatishda kelishiladigan organlar",
      children: <p>{text}</p>,
    },
    {
      key: "2",
      label:
        "Davlat xizmatini foydalanish uchun zarur boshqa turdagi ma’muriy tartib taomillar",
      children: <p>{text}</p>,
    },
    {
      key: "3",
      label: "Davlat xizmatini ko‘rsatish nuqtasi va axborot tizim(lar)i",
      children: <p>{text}</p>,
    },
    {
      key: "4",
      label: "Xizmatni olish uchun kerakli hujjatlar",
      children: <p>{text}</p>,
    },
    {
      key: "5",
      label: "To‘lov ma’lumotlari",
      children: <p>{text}</p>,
    },
    {
      key: "6",
      label: "Davlat xizmatidan foydalanish uchun zarur talab va shartlar",
      children: <p>{text}</p>,
    },
    {
      key: "7",
      label: "Davlat xizmatini ko‘rsatish natijasining amal qilish muddati",
      children: <p>{text}</p>,
    },
  ];

  return (
    <Modal
      open={!!hash}
      onCancel={navigate.bind(null, -1)}
      width="1072px"
      classNames={cls}
      closeIcon={<Times />}
      title={
        <>
          <Breadcrumb
            separator=">"
            style={{ color: "rgba(255, 255, 255, 0.6)", marginBottom: "8px" }}>
            <Breadcrumb.Item
              href="/"
              style={{ color: "rgba(255, 255, 255, 0.6)" }}>
              {t("turism", "Turizm")}
            </Breadcrumb.Item>
            <Breadcrumb.Item href="/service-register">
              {t(
                "service_register",
                "Turizm operatori faoliyati uchun sertifikat..."
              )}
            </Breadcrumb.Item>
          </Breadcrumb>
          <Space direction="vertical" size="middle">
            <h3>
              Turizm operatori faoliyati uchun sertifikat (Turizm sertifikati)
              olish — turistik xizmatlar ko‘rsatish huquqini tasdiqlovchi hujjat
            </h3>

            <List
              style={{
                backgroundColor: "rgba(255,255,255, 0.12)",
                color: " rgba(255, 255, 255, 0.6)",
                borderRadius: "16px",
                padding: "12px",
              }}
              itemLayout="horizontal"
              size="small"
              dataSource={data}
              bordered={false}
              renderItem={item => (
                <List.Item
                  style={{
                    color: "#fff",
                    borderBottom: "none",
                  }}>
                  <ArrowCurvedRight /> <span>{item.title}</span>
                </List.Item>
              )}
              header="Davlat xizmati kichik turining nomi"
            />
          </Space>

          <Row gutter={[8, 8]} className={cls.cards}>
            <Col xs={24} sm={12} lg={6}>
              <MetaDataCard
                icon={<Clock />}
                title="Arizani ko‘rib chiqish muddatlari"
                text="Avtomatik tarzda"
              />
            </Col>
            <Col xs={24} sm={12} lg={6}>
              <MetaDataCard
                icon={<Document />}
                title="Davlat xizmatini ko‘rsatish natijasi"
                text="Ma'lumotnoma"
              />
            </Col>
            <Col xs={24} sm={12} lg={6}>
              <MetaDataCard
                icon={<User />}
                title="Ariza beruvchilar toifasi"
                text="Yuridik va jismoniy shaxslar"
              />
            </Col>
            <Col xs={24} sm={12} lg={6}>
              <MetaDataCard
                icon={<Clock />}
                title="Xizmat narxi"
                text="412 000"
              />
            </Col>
          </Row>
        </>
      }>
      <Row gutter={[24]}>
        <Col xs={24} sm={12} lg={16}>
          <Collapse accordion size="large" items={items} bordered={false} />
        </Col>
        <Col xs={24} sm={12} lg={8}>
          <Space direction="vertical" size="middle" style={{ display: "flex" }}>
            <MetaDataCard
              icon={<Bank />}
              title="Vakolatli organ"
              text="Oʻzbekiston Respublikasi Axborot texnologiyalari va kommunikatsiyalarini rivojlantirish vazirligi"
              background="grey"
            />
            <Space size={16} />
            <MetaDataCard
              title="Xizmat ko‘rsatish nuqtasi va axborot tizim(lar)i"
              background="grey">
              <Space direction="vertical" style={{ display: "flex" }}>
                <ServicePoint imgSrc={myGov} title="My.gov.uz" />
                <ServicePoint imgSrc={birDarcha} title="Birdarcha.uz" />
                <ServicePoint
                  imgSrc={davXizmat}
                  title="Davlat xizmatlari markazi"
                />
              </Space>
            </MetaDataCard>
            <MetaDataCard
              icon={<Clock />}
              title="Natijaning amal qilish muddati"
              text="10 yil"
              background="grey"
            />
            <MetaDataCard
              icon={<Document />}
              title="Normativ hujjat"
              text="Avtomatik tarzda"
              background="grey"
            />
          </Space>
        </Col>
      </Row>
    </Modal>
  );
};

export default QuickViewModal;
